<template>
  <v-container fluid>
    <tab-nav/>

    <v-layout>
      <v-flex xs12 >
        <v-card
          v-if="tabActive === 0"
          flat
        >
          <model-display/>

        </v-card>
        <v-card
          v-if="tabActive === 1"
          flat
        >
          <model-edit/>
        </v-card>
        <v-card
          v-if="tabActive === 2"
          flat
        >
          <model-holdings/>
        </v-card>
        <v-card
          v-if="tabActive === 3"
          flat
        >
          <model-univami/>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ModelEdit from './ModelEdit'
import ModelDisplay from './ModelDisplay'
import Holdings from './Analytics/Holdings'
import UniVami from './Analytics/UniVami'

export default {
  components: {
    'model-edit': ModelEdit,
    'model-display': ModelDisplay,
    'model-holdings': Holdings,
    'model-univami': UniVami
  },

  props: [
    'uuid'
  ],

  data: () => ({
    navMenu: [
      { title: 'Summary' },
      { title: 'Edit' },
      { title: 'Holdings' },
      { title: 'Relative Value' }
    ]
  }),

  mounted: function () {
    if (this.uuid === null || this.uuid === undefined) {
      this.clearModelID()
      this.setModelID({ uuid: this.uuid })
    }
    this.clearSelectedPrices()
    this.loadBreadcrumbs(this.breadcrumbs)
    this.loadCurNav(this.navMenu)
  },

  watch: {
    tabActive (val) {
      console.log('Model:watch: tabActive val', val)
      if (val === 1) {
        console.log('watch:tabActive: calling model')
        this.startEditModel(this.model)
      }
    }
  },

  computed: {
    ...mapGetters({
      tabActive: 'nav/getTabActive',
      model: 'models/model'
    }),

    breadcrumbs () {
      var crumb = [
        { text: 'Dashboard', disabled: false, href: '/dashboard' },
        { text: 'Model s', disabled: false, href: '/model-s' }
      ]
      if (this.model !== undefined) {
        crumb.push({ text: this.model.portname, disabled: true })
      }
      return crumb
    }
  },

  methods: {
    ...mapActions({
      loadBreadcrumbs: 'nav/loadBreadcrumbs',
      loadCurNav: 'nav/loadCurNav',
      setModelID: 'models/setModelID',
      startEditModel: 'models/startEditModel',
      clearModelID: 'models/clearModelID',
      clearSelectedPrices: 'prices/clearSelectedPrices'
    })
  }
}
</script>
